import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { payInvoiceWithInvoiceId } from ".";

export default function usePayInvoice() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const {
    sessionId,
    sessionCtx: { isEscrow },
  } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ invoiceId }) => payInvoiceWithInvoiceId(ctx, invoiceId, isEscrow),
    onError: () => {
      // If we get an error back while paying the invoice, we need to invalidate the
      // cache for all invoice details so that the UI can reset
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
}
